import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ClipboardList } from "lucide-react";
import { toast } from "sonner";

export default function StockAudit() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      setLoading(true);
      const r = await api.get("/admin/stock-audit");
      setRows(r.data || []);
    } catch (e) {
      toast.error(
        e?.response?.data?.detail || "Unable to load stock audit"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="p-4 md:p-6 space-y-5">
      <div className="flex items-center gap-3">
        <div className="p-3 rounded-xl bg-emerald-100 text-emerald-700">
          <ClipboardList size={24} />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-slate-900">
            Stock Activity / Audit
          </h1>
          <p className="text-sm text-slate-500">
            Complete stock movement history
          </p>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-x-auto">
        {loading ? (
          <div className="p-6 text-slate-500">Loading stock activity...</div>
        ) : rows.length === 0 ? (
          <div className="p-6 text-slate-500">
            No stock activity recorded yet.
          </div>
        ) : (
          <table className="min-w-[1100px] w-full text-sm">
            <thead className="bg-slate-50">
              <tr>
                <th className="px-4 py-3 text-left">Date / Time</th>
                <th className="px-4 py-3 text-left">Admin</th>
                <th className="px-4 py-3 text-left">Company</th>
                <th className="px-4 py-3 text-left">Product</th>
                <th className="px-4 py-3 text-left">Action</th>
                <th className="px-4 py-3 text-right">Quantity (MT)</th>
                <th className="px-4 py-3 text-right">Previous (MT)</th>
                <th className="px-4 py-3 text-right">New Stock (MT)</th>
                <th className="px-4 py-3 text-left">Remarks</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-t border-slate-100">
                  <td className="px-4 py-3 whitespace-nowrap">
                    {r.created_at
                      ? new Date(r.created_at).toLocaleString()
                      : "—"}
                  </td>
                  <td className="px-4 py-3">
                    <div className="font-semibold">{r.admin_name || "—"}</div>
                    {r.admin_mobile && (
                      <div className="text-xs text-slate-500">
                        {r.admin_mobile}
                      </div>
                    )}
                  </td>
                  <td className="px-4 py-3">{r.company_name || "—"}</td>
                  <td className="px-4 py-3">{r.product_name || "—"}</td>
                  <td className="px-4 py-3 font-semibold">{r.action || "—"}</td>
                  <td className="px-4 py-3 text-right">
                    {Number(r.quantity_mt || 0).toFixed(3)}
                  </td>
                  <td className="px-4 py-3 text-right">
                    {Number(r.stock_before_mt || 0).toFixed(3)}
                  </td>
                  <td className="px-4 py-3 text-right font-semibold">
                    {Number(r.stock_after_mt || 0).toFixed(3)}
                  </td>
                  <td className="px-4 py-3">{r.remarks || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
